/**
 * iAmore Made to Order - Variant Change Handler
 * Listens to Impulse's documented variant:change event.
 * Data is provided by product-inventory.liquid via window.hcMadeToOrderData.
 * This file is never overwritten by theme updates.
 */
(function () {
  'use strict';

  function onVariantChange(variant) {
    var data = window.hcMadeToOrderData;
    if (!data) return;

    var hcShipping = document.querySelector('#hc-variant-shipping');
    if (!hcShipping) return;

    var variantData = data.variants[String(variant.id)];
    if (!variantData) return;

    var cartBtnText = document.querySelector('[data-add-to-cart-text]');
    var hcInvIcon = hcShipping.querySelector('.icon--inventory');

    // Update shipping / MTO message content
    hcShipping.innerHTML = variantData.shipping || '';

    if (variantData.isMadeToOrder) {
      hcShipping.style.display = 'block';
      if (cartBtnText) {
        // Only override if not sold out (theme handles sold out separately)
        var addToCartBtn = document.querySelector('[data-add-to-cart]');
        if (addToCartBtn && !addToCartBtn.disabled) {
          cartBtnText.textContent = data.labels.madeToOrder;
        }
      }
      if (hcInvIcon) hcInvIcon.classList.add('hc-made-icon');
      // "Made to order just for you" is shown by Impulse via waiting_for_stock locale string
    } else {
      hcShipping.style.display = 'none';
      if (hcInvIcon) hcInvIcon.classList.remove('hc-made-icon');
    }
  }

  document.addEventListener('variant:change', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    if (variant) onVariantChange(variant);
  });
})();
